import React, {Component} from 'react';
import './Tabber.css';

export default class Tabber extends Component {
    render() {
        return <div className={"Tabber"}>
            {this.props.children}
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/Portal/Parts/Tabber.js